//import React from "react";
import React, { useState, useEffect } from "react";
import { useLang } from "@/context/LanguageContext";
import { WHATSAPP_LINK } from "@/lib/packages";
import { ArrowRight, MessageCircle } from "lucide-react";

const HERO_VIDEO = "-https://cdn.coverr.co/videos/coverr-paragliding-over-the-hills-6172/1080p.mp4";
const HERO_VIDEO_ALT = "-https://cdn.coverr.co/videos/coverr-paragliding-in-new-zealand-3011/1080p.mp4";
//const HERO_POSTER = "https://images.unsplash.com/photo-1592208128295-5aaa34f1d72b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";
const HERO_POSTER = "https://ik.imagekit.io/paraglidetour/parapente-perez-zeledon-tandem-costa-rica-puravda-016.jpeg";

export default function Hero() {
  const { t } = useLang();



  return (
    <section data-testid="hero-section" className="relative h-[60vh] min-h-[640px] max-w-9xl mx-auto w-full overflow-hidden bg-jungle">
      <video
        data-testid="hero-video"
        className="absolute inset-0 w-full h-full object-cover scale-105"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        poster={t.hero.image}
        aria-label="Best Tandem Paragliding Tour in Costa Rica"
      >
        <source src={HERO_VIDEO} type="video/mp4" />
        <source src={HERO_VIDEO_ALT} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-b from-jungle/60 via-jungle/30 to-jungle/75" />
      <div className="absolute inset-0 grain" />

      <div className="relative z-10 h-full flex flex-col justify-end pb-0 md:pb-0 fade-up">
        <div className="max-w-6xl mx-auto w-full px-6 md:px-6">
          <div className="max-w-10xl border-round text-center">
            <h2 data-testid="hero-overline" className="font-overline  text-sand/90 text-xs mb-6 fade-up-delay-3">
              {t.hero.title}
            </h2>

            <h1 data-testid="hero-title" className="font-display text-3xl md:text-3xl lg:text-[32px] leading-[0.95] fade-up-delay-4">
              {t.hero.overline}
            </h1>
            <div className="mt-6 text-sand/90 text-lg md:text-xl max-w-auto leading-relaxed fade-up-delay-2">
              <a href="https://paraglidetour.com/book" data-testid="hero-book-btn" className="btn-primary">
                {t.hero.cta_book} <ArrowRight size={16} />
              </a>
              {/*
              <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" data-testid="hero-whatsapp-btn" className="btn-ghost" style={{borderColor: "rgba(247, 245, 240, 0.5)", color: "#F7F5F0"}}>
                <MessageCircle size={16} /> {t.hero.cta_whatsapp}
              </a>
              */}
            </div>
            <h3 data-testid="hero-subtitle" className="mt-6 text-sand/10 text-lg md:text-xl max-w-auto leading-relaxed fade-up-delay-5 hide-md">
              {t.hero.subtitle}
            </h3>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 md:right-12 z-5 text-sand/80 font-overline text-[10px] fade-up-delay-3">
      Rivas Pérez Zeledon · Dominicalito · Huacachina 
      </div>
    </section>



  );
}
